import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import React from 'react';

interface ChartWindowControlsProps {
  startLabel: string;
  endLabel: string;
  hasPrev: boolean;
  hasNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

const ChartWindowControls = ({ startLabel, endLabel, hasPrev, hasNext, onPrev, onNext }: ChartWindowControlsProps) => {
  return (
    <Box display='flex' alignItems='center' justifyContent='center' gap={2} mt={1}>
      <IconButton size='small' onClick={onPrev} disabled={!hasPrev} aria-label='Show earlier data'>
        <ChevronLeftIcon fontSize='small' />
      </IconButton>
      <Typography variant='bodyRegular' color='text.secondary'>
        {startLabel} – {endLabel}
      </Typography>
      <IconButton size='small' onClick={onNext} disabled={!hasNext} aria-label='Show later data'>
        <ChevronRightIcon fontSize='small' />
      </IconButton>
    </Box>
  );
};

export default React.memo(ChartWindowControls);
